import * as React from 'react'

import { AgesIcon, Strong, Text } from 'main/ui'

import { formatAge } from 'main/util/age'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-AGES`

interface IProps {
  ageMonthsMax: number
  ageMonthsMin: number
}

export default function Ages(props: IProps) {
  const { ageMonthsMin, ageMonthsMax } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const formattedAgeMin = formatAge(ageMonthsMin)
  const formattedAgesMax = formatAge(ageMonthsMax)

  return (
    <Bullet icon={<AgesIcon />}>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      <Text muted>
        {formattedAgeMin} &mdash; {formattedAgesMax}
      </Text>
    </Bullet>
  )
}
